<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content class="small-content">
    <p class="mb-4" *ngIf="data.content">{{data.content}}</p>
    <form [formGroup]="form">
        <label>{{data.label}}:</label>
        <input class="form-control" formControlName="inputValue">
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        Cancel
    </button>
    <button (click)="closeAndConfirm()" aria-label="confirm dialog" class="btn btn-primary">{{data.btnContent}}</button>
</mat-dialog-actions>
